import React, { useState } from "react";
import { AsyncPaginate } from "react-select-async-paginate";
import { listTypeDocument } from "../../services/pageOne";

const SelectAsyncTipoIdenti = (props) => {
  const [isDownload, setIsDownload] = useState(false);
  const [dataParams, setDataParams] = useState({});

  const getDefaultValue = async () => {
    const resp = await listTypeDocument(1);
    setDataParams(resp);
    setIsDownload(true);
    const defaultValue = resp.results.filter(
      (item) => item.codigo === "CC"
    )[0];
    props.onChange(defaultValue);
  };
  async function Options(searchQuery, { page }) {
    try {
      let resp = {};
      if (isDownload) {
        resp = dataParams;
      } else {
        resp = await listTypeDocument(1);
        setDataParams(resp);
        setIsDownload(true);
      }
      return {
        options: resp.results.filter((item) => item.codigo === "CC"),
        hasMore: resp.next !== null,
        additional: {
          page: searchQuery ? 2 : page + 1,
        },
      };
    } catch (error) {}
  }
  const onChange = (option) => {
    if (typeof props.onChange === "function") {
      props.onChange(option);
    }
  };
  return (
    <>
      <AsyncPaginate
        styles={props.styles}
        key={(option) => option.tipo_documentos}
        value={props.value || getDefaultValue || ""}
        loadOptions={Options}
        getOptionValue={(option) => option.tipo_documento}
        getOptionLabel={(option) => option.descripcion}
        onChange={onChange}
        placeholder="Seleccionar"
        additional={{
          page: 1,
        }}
        isSearchable
        filterOption={(option, inputValue) =>
          option.label.toLowerCase().includes(inputValue.toLowerCase())
        }
      />
    </>
  );
};

export default SelectAsyncTipoIdenti;
